import { Button } from "@progress/kendo-react-buttons";
import { useSelector } from "react-redux";

export const EditCommandCell = (props) => {
  const { user } = useSelector(state => state.authReducer);
  return (!props.user.viewOnly && !user.notificationOnly && (props?.dataItem?.site?.id ? user.site.id == props.dataItem.site.id : true)) ? (props.dataItem.email != props.user.email || props.dataItem.email_address ?
    (
      <td
style={ props.locked ? { 
        left: 0,
        right: 0,
        position: 'sticky',
        zIndex: 2,
        backgroundColor: 'white'
       } : {} }>
        <Button
          className="k-button k-primary k-flat"
          style={{ marginRight: "5px" }}
          onClick={() => props.enterEdit(props.dataItem)}
          iconClass="k-icon k-i-pencil"
        />
        <Button
          className="k-button k-flat"
          onClick={() => props.deleteEntry(props.dataItem)}
          iconClass="k-icon k-i-trash"
          style={{ color: 'red' }}
        />
      </td>
    ) : (
      <td
style={ props.locked ? { 
        left: 0,
        right: 0,
        position: 'sticky',
        zIndex: 2,
        backgroundColor: 'white'
       } : {} }>
        <Button
          className="k-button k-primary k-flat"
          style={{ marginRight: "5px" }}
          onClick={() => props.enterEdit(props.dataItem)}
          iconClass="k-icon k-i-pencil"
        />
      </td>
    )) : null;
};